import React from "react";
import {Button} from "primereact/button";
import {buildStrapiBackendPrompt} from "../utils/build-strapi-backend-prompt";

export default function StrapiPromptPreview({brief, translate, onCopy}) {
    const text = buildStrapiBackendPrompt(brief, translate);
    return (
        <section className="pbb-preview-panel">
            <div className="pbb-panel-header">
                <div>
                    <h2>{translate("pbb-strapi-prompt-preview")}</h2>
                    <p>{translate("pbb-strapi-prompt-preview-description")}</p>
                </div>
                <Button icon="pi pi-copy" text rounded onClick={() => onCopy(text)} tooltip={translate("pbb-copy-strapi-prompt")}/>
            </div>
            <pre>{text}</pre>
        </section>
    );
}
